import { X } from "lucide-react";
import { SlideHeader, Headline, Body, DeepDive, SiteLink } from "../shared";

export function Slide04Gap() {
  return (
    <div className="max-w-3xl" data-testid="pitch-slide-gap">
      <SlideHeader n="04" label="The Gap" />
      <Headline>
        Personalization has an <span className="text-accent">action problem.</span>
      </Headline>
      <div className="flex flex-wrap items-center gap-3 mt-6" data-testid="pitch-gap-visual">
        <div className="flex flex-wrap items-center gap-2">
          {["Recommends", "Detects", "Reminds"].map((w) => (
            <span
              key={w}
              className="font-mono text-[11px] tracking-[0.12em] uppercase text-zinc-400 border border-zinc-700 rounded-full px-3.5 py-2"
            >
              {w}
            </span>
          ))}
        </div>
        <div className="flex items-center gap-2 text-zinc-600" aria-hidden="true">
          <span className="w-6 sm:w-9 h-px border-t border-dashed border-zinc-600" />
          <span className="w-6 h-6 rounded-full border border-zinc-600 flex items-center justify-center shrink-0">
            <X size={12} />
          </span>
          <span className="w-6 sm:w-9 h-px border-t border-dashed border-zinc-600" />
        </div>
        <span className="font-mono text-[11px] tracking-[0.12em] uppercase text-white border border-accent bg-accent/10 rounded-full px-4 py-2.5">
          The Product: Not Yet Applied
        </span>
      </div>
      <Body>
        But none of that applies the product. When the moment arrives, the formulation still has
        to be found, opened and applied. WearSpray removes that friction by putting the user's
        chosen liquid, lotion or gel on the wrist.
      </Body>
      <p className="font-heading text-white text-lg md:text-xl font-medium mt-3 max-w-2xl">
        Awareness becomes access. <span className="text-accent">Access makes action possible.</span>
      </p>
      <div className="mt-6">
        <DeepDive testid="gap" title="Why Data Isn't Enough">
          <p className="font-body text-zinc-300 text-base leading-relaxed">
            Most wearables stop at data, a number on a screen, an alert you swipe away. WearSpray turns
            that understanding into action: the product you need is already on your wrist, one press away.
          </p>
          <SiteLink href="https://wearspray.com/technology">See the technology on wearspray.com</SiteLink>
        </DeepDive>
      </div>
    </div>
  );
}
